import { ModalController, NavController, Platform } from '@ionic/angular';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { isPresent } from 'src/providers/common-service';
// import { DatePicker } from '@awesome-cordova-plugins/date-picker/ngx';
import * as moment from 'moment';
import { SearchCriteria } from 'src/data/search-criteria';
import { ScorecardService } from 'src/providers/scorecard-service/scorecard-service';
import { Country } from 'src/data/country-location';
import { PlayerService } from 'src/providers/player-service/player-service';
import { EventObserver } from 'src/providers/event-service';
import { CountryListPage } from '../modal-screens/country-list/country-list.page';
@Component({
  templateUrl: 'scorecard-filter.page.html',
  styleUrls: ['scorecard-filter.page.scss'],
})
export class ScorecardFilterPage implements OnInit {
  searchCriteria: SearchCriteria;
  scorecardType: string;
  startDate: Date;
  endDate: Date;
  isoStartDate: string;
  isoEndDate: string;
  countryList: Array<Country>;
  @Input() filterData:any

  constructor(public platform: Platform,
    // private datePicker: DatePicker,
    private modalCtl: ModalController,
    public nav: NavController,
    private globalEventObserver: EventObserver,
    private scorecardService: ScorecardService,
    private playerService: PlayerService,
    private changeDetectorRef: ChangeDetectorRef

  ) {
    this.globalEventObserver.publishData("ScorecardSearchFilter")
    this.searchCriteria = scorecardService.getSearchCriteria();

    this.scorecardType = scorecardService.getScorecardType();

    if (!isPresent(this.searchCriteria.periodType))
      this.searchCriteria.periodType = "NONE";
    this.endDate = moment().toDate();
    this.startDate = moment().add(-1, "months").toDate();
    this.isoEndDate = moment().toISOString();
    this.isoStartDate = moment().add(-1, "months").toISOString();

  }

  ngOnInit() {
    this.getCountry();
    if(this.filterData) this.filterCountry = this.filterData
  }

  cancel() {
    this.modalCtl.dismiss(false);
  }

  onApplyClick() {


    this.scorecardService.setSearchCriteria(this.searchCriteria,
      this.scorecardType);
    if (this.searchCriteria.periodType === "CUSTOM") {
      if (this.isCordova()) {
        this.scorecardService.setFilterStartDate(this.startDate);
        this.scorecardService.setFilterEndDate(this.endDate);

      } else {


        let parseStartDate = moment(this.isoStartDate, "YYYY-MM-DD").toDate();
        let parseEndDate = moment(this.isoEndDate, "YYYY-MM-DD").toDate();

        this.scorecardService.setFilterStartDate(parseStartDate);
        this.scorecardService.setFilterEndDate(parseEndDate);

      }

    }
    else {

      this.scorecardService.setFilterStartDate(null);
      this.scorecardService.setFilterEndDate(null);
    }

    this.globalEventObserver.publishData("ScorecardSearchFilter")
    this.globalEventObserver.getObservable().subscribe((result: any) => {

      if (result.chanel == "ScorecardSearchFilter") {

      }
      // this.events.publish("ScorecardSearchFilter");
      // this.nav.pop();
      let data: any
      this.modalCtl.dismiss(data = {
        apply: true,
        searchCriteria: this.searchCriteria,
        filterCountry:this.filterCountry
      });
    })
  }

  isCordova() {
    return this.platform.is("capacitor");
  }

  startDateDisplay() {
    return moment(this.startDate).format("MMM DD, YYYY");
  }

  endDateDisplay() {
    return moment(this.endDate).format("MMM DD, YYYY");
  }

  onStartDateChange(event) {
    this.startDate = moment(event.target.value, "YYYY-MM-DD").toDate();
  }

  onEndDateChange(event) {
    this.endDate = moment(event.target.value, "YYYY-MM-DD").toDate();
  }

  onStartDateClick() {
    // this.datePicker.show({
    //   date: this.startDate,
    //   mode: "date"
    // }).then((date: Date) => {
    //   this.startDate = date;
    // })
  }

  onEndDateClick() {
    // this.datePicker.show({
    //   date: this.endDate,
    //   mode: "date"
    // }).then((date: Date) => {
    //   this.endDate = date;
    // });
  }

  maxPeriodLength(): number {
    if (this.searchCriteria.periodType) {
      switch (this.searchCriteria.periodType) {
        case "MONTH":
          return 60;
        case "DAY":
          return 500;
        case "WEEK":
          return 52;
        case "YEAR":
          return 5;
      }
    }
    return 0;
  }

  onPeriodTypeChange(event) {
    if (this.searchCriteria.periodType) {
      let maxValue = this.maxPeriodLength();
      if (!this.searchCriteria.periodLength || this.searchCriteria.periodLength > maxValue) {
        switch (this.searchCriteria.periodType) {
          case "MONTH":
            this.searchCriteria.periodLength = 1;
            break;
          case "DAY":
            this.searchCriteria.periodLength = 30;
            break;
          case "WEEK":
            this.searchCriteria.periodLength = 4;
            break;
          case "YEAR":
            this.searchCriteria.periodLength = 1;
            break;
          default:
            this.searchCriteria.periodLength = 0;
        }
      }

    }
  }

  getCountry() {
    this.playerService.getCountryList()
      .subscribe((data: Array<Country>) => {

        this.countryList = data;

      });
  }

  filterCountry: Country;
  async onSelectCountry() {
    let modal = await this.modalCtl.create({
      component: CountryListPage,
      componentProps: {
        country: this.countryList,
        headerName: 'Select Country',
        excludeAll: false,
      },
    });
   modal.onDidDismiss().then((country?: any) => {
      let _country: Country = country.data;
      if (!country.data || country.data === -999) {
        this.filterCountry = null
        this.searchCriteria.countryId = '';
      }
      else this.filterCountry = _country;
      this.searchCriteria.countryId = _country.id;
      setTimeout(()=>{
        this.getCountryInfo();
      },150)
      this.changeDetectorRef.detectChanges();
    });
    await modal.present();
  }

  getCountryInfo() {
    if (!this.filterCountry) {
      console.log("IFFFFF")
      // this.searchCriteria.countryId = ''
      console.log(' this.searchCriteria.countryId: ',  this.searchCriteria.countryId);
      return 'All Countries'
    }
    else {
      console.log("ELSEEEEE")
      // this.searchCriteria.countryId = this.filterCountry?.id
      return this.filterCountry && this.filterCountry?.name};
  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl == null || flagUrl == '')
      return '../../../../assets/img/flag/default_worldwide.png';
    else {
      let flagIcon = flagUrl.split('/');
      return '../../../../assets/img/flag/' + flagIcon[2];
    }
  }
}
